import type { SagaIterator } from 'redux-saga';
import { getContext, takeEvery } from 'redux-saga/effects';
import { CLIENT_CONTEXT } from '@peloton/api';
import { UserReducerActionType } from '@peloton/auth';
import { loadUserSaga, logOutUserSaga, logInUserSaga } from '@peloton/auth/sagas';
import { onForgotPasswordSaga, ForgotPasswordActionType } from '@peloton/forgot-password';

const authSaga = function* (): SagaIterator {
  const client = yield getContext(CLIENT_CONTEXT);
  yield takeEvery(UserReducerActionType.REQUEST, loadUserSaga, client);
  yield takeEvery(UserReducerActionType.LOGOUT, logOutUserSaga, client);
  yield takeEvery(UserReducerActionType.LOGIN, logInUserSaga, client);
  yield takeEvery(ForgotPasswordActionType.REQUEST, onForgotPasswordSaga, client);
};

export default authSaga;
